import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'makeUpper'
})
export class MakeUpperPipe implements PipeTransform {

  transform(value: string): any {
    if(!value) return;
    let newValue = value.replace(/([A-Z])/g, ' $1').trim()
    return newValue;
  }

}
